<template>
    <div class="orderorder">
        <!-- 单据功能按钮 -->
        <div
            style="display: flex; align-items: center; justify-content: space-between; padding: 0 10px; box-sizing: border-box">
            <div style="display: flex; align-items: center">
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg)"
                    alt=""
                    @click="isAdd == true || !isEdit == true ? '' : changePage('1')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg); margin: 0 15px"
                    alt=""
                    @click="isAdd == true || !isEdit == true ? '' : changePage('2')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px; margin-right: 15px"
                    alt=""
                    @click="isAdd == true || !isEdit == true ? '' : changePage('3')"
                />
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px"
                    alt=""
                    @click="isAdd == true || !isEdit == true ? '' : changePage('4')"
                />
            </div>
            <div style="float: right">
                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    :disabled="isAdd || !isEdit"
                    @click="add"
                    v-if="perData.allow_add == 1"
                >{{ $t('common.add') }}
                </el-button
                >
                <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-edit"
                    :disabled="isAdd || !isEdit || isCheck || nullBtn"
                    @click="handelEdit"
                    v-if="perData.allow_edit == 1"
                >{{ $t('common.edit') }}
                </el-button
                >
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    :disabled="isAdd || !isEdit || isCheck || nullBtn"
                    @click="delOrder"
                    v-if="perData.allow_dele == 1"
                >{{ $t('common.delete') }}
                </el-button>
                <el-button type="info" size="mini" @click="goHistory" :disabled="!isEdit">{{ $t('common.historyBill') }}</el-button>
                <el-button type="primary" :disabled="isAdd || !isEdit || nullBtn" plain @click="Check(form.check)">{{
                        form.check == 1 ? $t('common.cancelAudit') : $t('common.audit')
                    }}
                </el-button>
            </div>
        </div>
        <!-- 单据操作信息 -->
        <div class="top_col">
            <el-row :gutter="20">
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.creator') }}：<span>{{ form.build_name }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifier') }}：<span>{{ form.modify_name }}</span>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="grid-content bg-purple">
                        {{ $t('common.createTime') }}：<span>{{ form.build_date }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifyTime') }}：<span>{{ form.modify_date }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditor') }}：<span>{{ form.check_name }}</span>
                    </div>
                </el-col>
                <el-col :span="2">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditStatus') }}：<span
                        :style="{ color: form.check == 1 ? '' : 'red' }">{{ form.check == 1 ? $t('common.audited') : $t('common.notAudited')
                        }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditTime') }}<span>{{ form.check_date }}</span>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 主表表单 -->
        <div class="top_cols" style="padding-bottom: 0">
            <el-form :model="form">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-form-item :label="$t('common.billNo') + '：'" label-width="180">
                            <el-input v-model="form.bill_no" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.billDate') + '：'" label-width="180" required>
                            <el-date-picker
                                type="datetime"
                                :disabled="isEdit"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期"
                                v-model="form.bill_date"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item :label="$t('common.billType') + '：'" required>
                                <mySelect
                                    v-model="form.billtype_no"
                                    :options="allPullArr.billtype"
                                    values="billtype_no"
                                    labels="billtype_name"
                                    keys="billtype_no"
                                    :disable="isEdit"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.customer') + '：'" label-width="180" required>
                            <mySelectOptimized
                                v-model="form.cust_no"
                                :options="allPullArr.cust"
                                values="cust_no"
                                labels="cust_name"
                                keys="cust_no"
                                :disable="isEdit"
                                @input="selectCust"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.salesman') + '：'" label-width="180">
                            <mySelect
                                v-model="form.salesman_no"
                                :options="allPullArr.salesman"
                                values="salesman_no"
                                labels="salesman_name"
                                keys="salesman_no"
                                :disable="isEdit"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item :label="$t('common.currency') + '：'">
                                <mySelect
                                    v-model="form.currency_no"
                                    :options="allPullArr.currency"
                                    values="currency_no"
                                    labels="currency_name"
                                    keys="currency_no"
                                    :disable="isEdit"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.handler') + '：'" label-width="180">
                            <mySelect
                                v-model="form.staff_no"
                                :options="allPullArr.staff"
                                values="staff_no"
                                labels="staff_name"
                                keys="staff_no"
                                :disable="isEdit"
                            />
                        </el-form-item>
                    </el-col>

                    <el-col :span="4" v-if="systemSet.isstores == 1">
                        <div class="input_col">
                            <el-form-item :label="$t('common.store') + '：'">
                                <mySelect
                                    v-model="form.store_no"
                                    :options="allPullArr.store"
                                    values="store_no"
                                    labels="store_name"
                                    keys="store_no"
                                    :disable="isEdit"
                                    :clearables="false"
                                    @input="selectStore"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="systemSet.isstores == 1 ? 16 : 20">
                        <el-form-item label-width="200" :label="$t('common.remark') + '：'">
                            <el-input type="textarea" :rows="1" v-model="form.remark" :disabled="isEdit"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <!-- 货品明细表格 -->
        <div class="table1" @mouseleave="dtlleave">
            <!--            <div class="title" @click="dtlTableShow = !dtlTableShow">-->
            <div class="title">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                    <span>{{ $t('common.productDetail') }}</span>
                    <!--                    <i class="el-icon-caret-right" v-if="!dtlTableShow"></i>-->
                    <!--                    <i class="el-icon-caret-bottom" v-else></i>-->
                    <vxe-input
                        :disabled="isEdit"
                        placeholder="请输入批次号"
                        @keydown.native.enter="insertBatchData($event,'batchno')"
                        v-model="insertBatchno"
                        clearable
                        style="width: 200px; margin-left: 10px"
                    >
                    </vxe-input>
                    <vxe-input
                        :disabled="isEdit"
                        placeholder="请输入提纯发出单号"
                        @keydown.native.enter="insertBatchData($event,'billno')"
                        v-model="insertBillno"
                        clearable
                        style="width: 200px; margin-left: 10px"
                    >
                    </vxe-input>
                </div>
            </div>
            <div v-show="dtlTableShow">
                <vxe-table
                    border
                    stripe
                    resizable
                    keep-source
                    align="center"

                    ref="dtlTable"
                    :height="maxHeight"
                    show-overflow
                    highlight-hover-row
                    :loading="loading"
                    show-footer-overflow
                    :footer-method="footerMethodDtl"
                    show-footer
                    :keyboard-config="{ isArrow: true, isDel: true, isEdit: true }"
                    :row-class-name="rowChange"
                    :data="form.dtl"
                    :mouse-config="{ selected: true }"
                    :edit-config="{ trigger: 'click', mode: 'row', icon: 'fa fa', activeMethod: activeRowMethod }"
                    @cell-mouseenter="dtlenter"
                    :key="refushTable"
                    @checkbox-change="checkboxChangeEvent"
                    @checkbox-all="checkboxChangeEvent"
                    :scroll-y="{ enabled: true, gt: 50 }"
                    :tooltip-config="{}"
                >
                    <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                    <vxe-table-column type="seq" field="seq" width="70" title="序号">
                        <template slot="header">
                            <i class="el-icon-setting" @click.stop="isEdit ? changeTable(1) : null"></i>
                        </template>
                        <template slot-scope="scoped">
                        <span class="add_" v-if="scoped.$rowIndex == dtlIndex">
                             <i class="el-icon-circle-plus-outline" @click="addDtl"></i>
                            <i class="el-icon-remove-outline" @click="delDtl(scoped)"></i>
                        </span>
                            <span v-if="scoped.$rowIndex != dtlIndex">
                            <i style="font-style: normal">{{ scoped.seq }}</i>
                        </span>
                        </template>
                    </vxe-table-column>

                    <template v-for="(item, index) in rkKeyList">
                        <vxe-table-column
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{
                            name: 'input',
                            attrs: { type: item.column_type },
                            autoselect: true,
                            autofocus: '.vxe-input--inner'
                        }"
                            v-if="
                            item.column_status == 1 &&
                            item.column_type != 'select' &&
                            item.field != 'initial_trans_wgt' &&
                            item.field != 'final_trans_wgt' &&
                            item.field != 'loss_wgt'
                        "
                        >
                            <template #header="{ column }" v-if="item.batch == 1">
                                <span>{{ column.title }}</span>
                                <el-dropdown trigger="click" :hide-on-click="flagFalse">
                                    <el-button
                                        class="batchBtn"
                                        type="primary"
                                        plain
                                        :disabled="isEdit || item.column_disabled == 1"
                                        @click="batchclick"
                                    >批量
                                    </el-button
                                    >
                                    <el-dropdown-menu slot="dropdown" style="padding: 15px">
                                        <el-radio-group v-model="batchOption">
                                            <div style="display: flex">
                                                <div style="margin-right: 10px">
                                                    <div style="">
                                                        <el-radio label="1">所有行修改为</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="2">选中行及以下行修改为</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="5">选中行修改为</el-radio>
                                                    </div>
                                                </div>

                                                <div style="margin-right: 10px">
                                                    <div style="">
                                                        <el-radio label="3">所有行加减</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="4">选中行及以下行加减</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="6">选中行加减</el-radio>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-radio-group>
                                        <div style="padding-top: 5px"></div>
                                        <el-form :inline="true">
                                            <el-form-item label="">
                                                <vxe-input
                                                    style="width: 280px"
                                                    :type="item.column_type"
                                                    v-model="batchSelect"
                                                    @blur="batchOperation($event, column.property)"
                                                ></vxe-input>
                                            </el-form-item>
                                        </el-form>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                            <template v-slot:edit="{ row }">
                                <vxe-input
                                    type="text"
                                    @input="handleInput(row, item.field, item.column_type)"
                                    @keydown.native="jumptable($event, row, item.field,'dtlTable')"
                                    v-model="row[item.field]"
                                    @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                    :disabled="item.column_disabled == 1"
                                ></vxe-input>
                            </template>
                        </vxe-table-column>
                        <!--  下拉选择字段 -->
                        <vxe-table-column
                            v-if="item.column_status == 1 && item.column_type == 'select'"
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{ autofocus: '.el-input__inner' }"
                        >
                            <template #default="{ row }">
                            <span>{{
                                    $selectLable.selectLable(
                                        row[item.field],
                                        allPullArr[item.field.replace('_no', '')],
                                        item.field,
                                        item.field.replace('_no', '_name')
                                    )
                                }}</span>
                            </template>
                            <template v-slot:edit="{ row }">
                                <el-select
                                    size="mini"
                                    v-model="row[item.field]"
                                    ref="stylefocus"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    @keydown.native="jumptable($event, row, item.field,'dtlTable')"
                                    :disabled="item.column_disabled == 1"
                                >
                                    <el-option
                                        v-for="option in allPullArr[item.field.replace('_no', '')] || []"
                                        :key="option[item.field.replace('_no', '') + '_no']"
                                        :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                        option[item.field.replace('_no', '') + '_name']
                                    }`"
                                        :value="option[item.field.replace('_no', '') + '_no']"
                                        :disabled="option.status == 0"
                                    ></el-option>
                                </el-select>
                            </template>
                        </vxe-table-column>
                        <!--  初测折足重量 -->
                        <vxe-table-column
                            field="initial_trans_wgt"
                            :title="item.column_name"
                            :width="item.column_width"
                            v-if="item.field == 'initial_trans_wgt' && item.column_status == 1"
                            :key="item.field + index"
                            :edit-render="{}"
                            class-name="jump"
                        >
                            <template v-slot:edit="{ row }">
                                <span>{{ countDtlInitialTransWgt(row).toFixed(systemSet.amt) }}</span>
                            </template>
                        </vxe-table-column>
                        <!--  提纯折足重量 -->
                        <vxe-table-column
                            field="final_trans_wgt"
                            :title="item.column_name"
                            :width="item.column_width"
                            v-if="item.field == 'final_trans_wgt' && item.column_status == 1"
                            :key="item.field + index"
                            :edit-render="{}"
                            class-name="jump"
                        >
                            <template v-slot:edit="{ row }">
                                <span>{{ countDtlFinalTransWgt(row).toFixed(systemSet.amt) }}</span>
                            </template>
                        </vxe-table-column>
                        <!--  损耗重量 -->
                        <vxe-table-column
                            field="loss_wgt"
                            :title="item.column_name"
                            :width="item.column_width"
                            v-if="item.field == 'loss_wgt' && item.column_status == 1"
                            :key="item.field + index"
                            :edit-render="{}"
                            class-name="jump"
                        >
                            <template v-slot:edit="{ row }">
                                <span>{{ countDtlLossWgt(row).toFixed(systemSet.wgt) }}</span>
                            </template>
                        </vxe-table-column>

                    </template>

                    <template #empty>
                    <span style="color: red">
                        <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                    </span>
                    </template>
                </vxe-table>
            </div>
        </div>
        <!-- 页脚表单 -->
        <div class="footer">
            <el-form :inline="true">
                <div>
                    <el-form-item label="旧料重量：">
                        <p>{{ form.sum_old_wgt }}</p>
                    </el-form-item>
                    <el-form-item label="初测重量：">
                        <p>{{ form.sum_initial_trans_wgt }}</p>
                    </el-form-item>
                    <el-form-item label="提纯重量：">
                        <p>{{ form.sum_final_trans_wgt }}</p>
                    </el-form-item>
                    <el-form-item label="损耗重量：">
                        <p>{{ form.sum_loss_wgt }}</p>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-button type="" size="mini" :disabled="isEdit" @click="refreshData(form.id)" style="width: 73px">
                    {{ $t('common.cancel') }}
                </el-button>
                <el-button type="primary" :disabled="isEdit" size="mini" @click="saveItSub">{{ $t('common.save') }}</el-button>
            </div>
        </div>
        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false"
                   destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index"
                                       @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost"
                                       :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2"
                                           v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {
    apiPurifyAlloyGetData,
    apiPurifyAlloyGetPull,
    apiPurifyAlloyUpdateData,
    apiPurifyAlloyAddData,
    apiPurifyAlloyDelData,
    apiPurifyAlloycheck,
    apiCurrentPermisson,
    apiSystem,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData,
    apiPurifyAlloyGetPurifyData,
} from '@/request/api';
import { translateColumns } from '@/utils/columnI18n';

export default {
    name: 'purifyalloy',
    data() {
        return {
            dtlTableShow: true,
            AmtTotal: 0,
            insertBatchno: '',//批次号输入框
            allPullArr: '',//存储下拉内容
            form: { remark: '' },//全局数据
            isEdit: true,//是否可编辑
            isCheck: false,//是否审核
            first: null,//是否有上一条
            last: null,//是否有下一条
            dialogImageUrl: '',
            isAdd: false,
            loading: false,
            nullBtn: false,
            systemSet: '',
            dtlIndex: '-1', //列表当前位置,
            isSave: true,
            type: '4',
            maxHeight: 500,
            showImpotDialog: false,
            headers: {},
            topIptInsjOrder: '',
            topLeftForm: {},
            billIndex: '-1',
            amtIndex: '-1',
            insertKeyword: '',
            insertKeywords: [],
            insertBillno: '',
            // 防抖
            debounceTimeout: null, // 用于存储防抖定时器
            // 批量字段
            batchSelect: '',
            selectRecords: 0,
            batchOption: '1',
            flagFalse: false,
            //列表擦操作字段
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            rkKeyList: [],
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            zkKeyList: [],
            fkKeyList: [],
            keyStatus: '74',
            perData: {}, //权限

            // 打印字段
            printData: { isshow: false, scope: null, index: 0, data: {} },
            DataDtl: { is_cunqian: {}, is_tot: {}, remark: {}, company: {} },
            fields3: [],
            fields2: [],
            fields1: [],
            query: {},
            pullList: {},
            printList: {},
            uploadData: {}
        };
    },
    mounted() {
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        this.getPullData();
        this.getDtlTableKey();
        this.getPermission();
        document.addEventListener('keydown.native', this.mykeyup);
        // this.geData();
        let token = sessionStorage.getItem('userToken');
        this.headers.Authorization = 'Bearer ' + token;
        if (this.$route.query.isadd == 0) {
            this.add();
        } else {
            this.geData();
        }
        
        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    activated() {
        let bill_no = this.$route.query.bill_no;
        if (bill_no) {
            this.geData();
        }
    },
    methods: {
        selectStore(e) {
        },
        selectCounter(e) {
        },

        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },

        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '186'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        //历史单据
        goHistory() {
            this.$router.push({ path: '/purifyalloyStorageHistory', query: { page: 'PurifyAlloyManage' } });
        },

        // 单据切页
        changePage(v) {
            this.type = v;
            let bill_nos = this.$route.query.bill_no;
            if (bill_nos) {
                this.$router.replace({ path: '/purifyalloy' });
                this.geData(this.form.id);
                return;
            }
            this.geData(this.form.id);
        },

        // 表格内批量操作
        batchclick() {
            this.batchSelect = '';
        },
        batchOperation(e, r) {
            if (e.value) {
                var table1 = this.$refs.dtlTable.getTableData().fullData;
                if (this.batchOption == '1') {
                    for (let i = 0; i < table1.length; i++) {
                        table1[i][r] = e.value;
                    }
                } else if (this.batchOption == '2') {
                    let selectedRowIndex = --this.selectRecords[0].seq;
                    for (let i = selectedRowIndex; i < table1.length; i++) {
                        table1[i][r] = e.value;
                    }
                } else if (this.batchOption == '3') {
                    for (let i = 0; i < table1.length; i++) {
                        table1[i][r] = Number(table1[i][r]) + Number(e.value);
                    }
                } else if (this.batchOption == '4') {
                    let selectedRowIndex = --this.selectRecords[0].seq;
                    for (let i = selectedRowIndex; i < table1.length; i++) {
                        table1[i][r] = Number(table1[i][r]) + Number(e.value);
                    }
                } else if (this.batchOption == '5') {
                    // 处理多个选中的行修改为指定值
                    for (let i = 0; i < this.selectRecords.length; i++) {
                        let selectedRowIndex = --this.selectRecords[i].seq;
                        if (selectedRowIndex >= 0 && selectedRowIndex < table1.length) {
                            table1[selectedRowIndex][r] = e.value; // 修改选中行的指定列值
                        }
                    }
                } else if (this.batchOption == '6') {
                    // 处理多个选中的行加减
                    for (let i = 0; i < this.selectRecords.length; i++) {
                        let selectedRowIndex = --this.selectRecords[i].seq;
                        if (selectedRowIndex >= 0 && selectedRowIndex < table1.length) {
                            // 对选中行进行加减
                            table1[selectedRowIndex][r] = Number(table1[selectedRowIndex][r]) + Number(e.value);
                        }
                    }
                }
                for (let i = 0; i < table1.length; i++) {
                    this.countDtlTransWgt(table1[i]);
                    this.countDtlOriginalAmt(table1[i]);
                    this.countDtlAmt(table1[i]);
                }
                this.flagFalse = false;
            }
        },
        checkboxChangeEvent({ records }) {
            this.selectRecords = records;
        },
        messageShow(res) {
            if (res.data.info instanceof Array) {
                let str = [];
                var s = '';
                str = res.data.info;
                for (let i = 0; i < str.length; i++) {
                    s += str[i] + '<br/>';
                }
                this.$message({
                    type: 'error',
                    showClose: true,
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: s
                });
            } else {
                this.$message.success(res.data.info);
            }
        },
        // 选择客户赋值对应的业务员
        selectCust(value) {
            if (value) {
                let item = this.allPullArr.cust.filter((item) => item.cust_no == value);
                this.$set(this.form, 'salesman_no', item[0].salesman_no);
                this.$forceUpdate();
            }
        },
        //输入批次号
        async insertBatchData(e, type) {
            const v = e.target.value.trim(); // 去除空格
            if (v) {
                if (e.keyCode == 16 || e.keyCode == 13) {
                    // 只处理回车键
                    clearTimeout(this.debounceTimeout); // 清除上一个定时器
                    this.debounceTimeout = setTimeout(async () => {
                        const isDuplicate = this.$refs.dtlTable.getTableData().fullData.some((row) => row.batchno === v);
                        if (isDuplicate) {
                            this.$message.error('输入的批次号不能重复。');
                            this.insertBatchno = '';
                            return;
                        }
                        try {
                            const res = await apiPurifyAlloyGetPurifyData({
                                no: v,
                                type: type,
                                cust_no: this.form.cust_no,
                                store_no: this.form.store_no
                            });
                            if (res.code == 2000) {
                                if (type == 'batchno') {
                                    const record = res.data.data; // 直接复制数据
                                    this.insertBatchno = ''; // 清空输入框
                                    await this.$refs.dtlTable.insertAt(record, -1);
                                }
                                if (type == 'billno') {
                                    const records = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
                                    this.insertBillno = ''; // 清空输入框
                                    await this.$refs.dtlTable.reloadData(records);
                                }
                                this.messageShow(res);
                            } else {
                                this.$message.error(res.data.info);
                                this.insertBatchno = '';
                                this.insertBillno = '';
                            }
                        } catch (error) {
                            console.error('请求失败:', error);
                            this.$message.error('请求失败，请重试。');
                        }
                    }, 300); // 设置防抖延迟时间
                }
            }
        },
        // 快捷键保存
        mykeyup(e) {
            var key = window.event.keyCode ? window.event.keyCode : window.event.which;
            if (key === 83 && e.ctrlKey) {
                // this.save('hot key');
                if (!this.isEdit) {
                    if (this.$route.path == '/purifyalloy') {
                        this.saveItSub();
                        e.preventDefault();
                        e.returnValue = false;
                    }
                }
            }
        },

        // 获取页面信息-----------------------------------------
        geData(no) {
            this.$load.show();
            this.isEdit = true;
            let bill_nos = this.$route.query.bill_no;
            let ids = this.$route.query.id;
            let bill_no = '';
            let id = '';
            if (bill_nos || ids) {
                this.type = null;
                bill_no = bill_nos;
                id = ids;
            }
            if (no) {
                id = no;
            }
            this.isAdd = false;
            apiPurifyAlloyGetData({
                type: this.type,
                id,
                bill_no
            }).then((res) => {
                if (res.code == 2000) {
                    let info = res.data;
                    this.form = info.data;
                    this.last = info.last;
                    this.first = info.first;
                    this.topLeftForm = info.data.inmain;
                    // this.maxHeight = 480;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    this.type = '4';
                    if (res.data.info == '暂无数据' || res.data.info == '没有这条数据') {
                        this.form = { dtl: [], bill: [], amt: [] };
                        this.$forceUpdate();
                        this.nullBtn = true;
                    }
                    this.$message.error(res.data.info);
                }
            }).catch((error) => {
                // 处理请求错误的情况
                this.$message.error('请求失败');
                console.error(error);
            }).finally(() => {
                // 无论请求成功或失败都关闭加载提示
                this.$load.close();
            });
        },

        // =====================================================================
        // ========================= 列配置相关接口 begin =========================
        // =====================================================================
        getDtlTableKey() {
            apiGetListCorrespondingData({
                id: '103'
            }).then((res) => {
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },

        changeTable(type) {
            if (type == 1) {
                this.keyList = this.rkKeyList.map((item) => item);
                this.keyStatus = '103';
            }
            this.drawers = true;
        },

        checkMove() {
        },
        // 列配置弹窗取消按钮事件
        keycancel() {
            this.drawers = false;
            this.getDtlTableKey();
        },
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // =====================================================================
        // ========================= 列配置相关接口 end =========================
        // =====================================================================

        // 获取下拉框信息---------------------------------------
        getPullData() {
            apiPurifyAlloyGetPull({}).then((res) => {
                if (res.code == 2000) {
                    this.allPullArr = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 撤回操作--------------------------------------
        refreshData(no) {
            this.isEdit = true;
            this.isAdd = false;
            this.form = { dtl: [], amt: [], bill: [] };
            this.type = 4;
            this.geData(no);
            if (this.$route.query.isadd == 0) {
                this.$router.replace('/purifyalloy');
            }
        },
        //首次进入页面 页面不可编辑状态--------------------------------
        handelEdit() {
            this.isSave = true;
            if (this.isEdit == true) {
                if (this.form.check == 0) {
                    this.isEdit = false;
                    if (this.form.dtl.length == 0) {
                        this.insertEventDtlTable(-1);
                    }
                } else if (this.form.check == 1) {
                    this.isCheck = true;
                }
            }
        },
        // 保存
        saveItSub() {
            this.saveIt();
        },
        // 保存修改------------------------------------------
        saveIt() {
            if (this.isSave) {
                this.isSave = false;
                let data = this.$deepClone(this.form);
                data.dtl = this.$refs.dtlTable.getTableData().fullData;
                this.$load.show();
                if (this.isAdd == true) {
                    apiPurifyAlloyAddData({ ...data }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('添加成功'); //添加商品
                            let info = res.data;
                            this.form = info.data;
                            this.last = info.last;
                            this.first = info.first;
                            this.topLeftForm = info.data.inmain;
                            this.isAdd = false;
                            this.isEdit = true;
                            if (this.$route.query.isadd == 0) {
                                this.$router.replace('/purifyalloy');
                            }
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                } else {
                    apiPurifyAlloyUpdateData({ ...data }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('修改成功'); //修改商品
                            let info = res.data;
                            this.form = info.data;
                            this.last = info.last;
                            this.first = info.first;
                            this.topLeftForm = info.data.inmain;
                            this.isEdit = true;
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                }
                this.insertKeywords = [];
                this.dynamicTags = [];
            }
        },
        //添加产品-----------------------------------
        add() {
            this.isSave = true;
            if (this.isAdd == false) {
                this.isEdit = false;
                this.form = { bill_date: '' };
                this.topLeftForm = {};
                this.form.check = false;
                this.isAdd = true;
                this.isCheck = false;
                this.nullBtn = false;
                this.form.bill_date = this.$getTime();
                // this.maxHeight = 480;
                const keys = Object.keys(this.allPullArr);
                const formKeys = keys.map((key) => `${key}_no`);
                keys.forEach((key, index) => {
                    if (Array.isArray(this.allPullArr[key])) {
                        // 确保 this.allPullArr[key] 是一个数组，而不是 undefined 或 null
                        const defaultItem = this.allPullArr[key].find((item) => item.isdefault == 1);
                        if (defaultItem) {
                            // 确保 defaultItem 和属性 formKeys[index] 存在
                            if (defaultItem.hasOwnProperty(formKeys[index])) {
                                this.form[formKeys[index]] = defaultItem[formKeys[index]];
                            } else {
                                console.warn(`Property ${formKeys[index]} does not exist on defaultItem`);
                                this.form[formKeys[index]] = ''; // 如果属性不存在，给它赋个默认值
                            }
                        } else {
                            // 如果没有找到 defaultItem，可能需要给 this.form[formKeys[index]] 设置一个默认值
                            console.warn(`No defaultItem found for key ${key}`);
                            this.form[formKeys[index]] = '';
                        }
                    } else {
                        // 如果 this.allPullArr[key] 不是一个数组，输出警告
                        console.warn(`Expected an array for key ${key}, but found ${typeof this.allPullArr[key]}`);
                    }
                });
                setTimeout(() => {
                    for (let i = 0; i < 3; i++) {
                        this.insertEventDtlTable(-1);
                        this.insertEventBillTable(-1);
                        this.insertEventAmtTable(-1);
                    }
                }, 100);
            } else {
                this.$message.error('请先保存再添加下一个');
            }
            this.type = '4';
        },
        //删除单据-----------------------------------------
        delOrder() {
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                apiPurifyAlloyDelData({
                    id: this.form.id
                }).then((res) => {
                    if (res.code == 2000) {
                        this.$message({ message: '删除成功', type: 'success' });
                        if (res.data.data == null) {
                            this.form = {};
                            this.nullBtn = true;
                        } else {
                            this.form = res.data.data;
                            if (this.form.check == 1) {
                                this.isCheck = true;
                            } else {
                                this.isCheck = false;
                            }
                        }
                        this.last = res.data.last;
                        this.first = res.data.first;
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            });

        },
        // 获取seq---------------------------
        rowChange(row) {
            row.row.seq = row.seq;
        },
        //审核按钮
        Check(val) {
            let check;
            if (this.form.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            apiPurifyAlloycheck({
                id: this.form.id,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    if (this.form.check == 0) {
                        this.isCheck = true;
                    } else {
                        this.isEdit = true;
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
                this.type = '';
                this.geData(this.form.id);
            });
        },
        //插入新数据--------------------------------------------
        async insertEventDtlTable(row) {
            let record = {
                style_no: '',
                alloy: 1,
                discount: 1
            };
            let { row: newRow } = await this.$refs.dtlTable.insertAt(record, row);
            await this.$refs.dtlTable.setActiveCell(newRow, 'seq');
        },

        // 列表出现新增
        dtlenter(row) {
            if (!this.isEdit) {
                this.dtlIndex = row.$rowIndex;
            }
        },
        dtlleave() {
            this.dtlIndex = '-1';
        },

        addDtl() {
            this.insertEventDtlTable(-1);
        },
        delDtl(scoped) {
            let length = this.$refs.dtlTable.getTableData().fullData.length;
            this.$refs.dtlTable.remove(scoped.row);
            if (length == 1) {
                $this.addDtl();
            }
        },
        // 不可编辑-------------------------------------
        activeRowMethod() {
            if (this.isEdit == false) {
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },
        // 表格行计算
        countDtlInitialTransWgt(row) {
            var b = this.$utils.multiply(Number(row.old_wgt || 0), Number(row.initial_alloy || 1));
            row.initial_trans_wgt = Number(b).toFixed(this.systemSet.wgt);
            return b;
        },
        countDtlFinalTransWgt(row) {
            var b = this.$utils.multiply(Number(row.old_wgt || 0), Number(row.final_alloy || 1));
            row.final_trans_wgt = Number(b).toFixed(this.systemSet.wgt);
            return b;
        },
        countDtlLossWgt(row) {
            this.countDtlFinalTransWgt(row);
            var a = Number(row.initial_trans_wgt || 0) - Number(row.final_trans_wgt || 0);
            row.loss_wgt = Number(a).toFixed(this.systemSet.wgt);
            return a;
        },

        sumNum(list, field) {
            let count = 0;
            list.forEach((item) => {
                count += Number(item[field]);
            });
            return count;
        },

        // 货品明细表格底部汇总
        footerMethodDtl({ columns, data }) {
            const systemSet = this.systemSet;

            // 预计算常用的合计值
            const totals = {
                old_wgt: this.$utils.sum(data, 'old_wgt').toFixed(systemSet.wgt),
                initial_trans_wgt: this.$utils.sum(data, 'initial_trans_wgt').toFixed(systemSet.wgt),
                final_trans_wgt: this.$utils.sum(data, 'final_trans_wgt').toFixed(systemSet.wgt),
                loss_wgt: this.$utils.sum(data, 'loss_wgt').toFixed(systemSet.wgt),
            };

            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    }

                    switch (column.property) {
                        case 'old_wgt':
                            this.$set(this.form, 'sum_old_wgt', totals.old_wgt);
                            return totals.wgt;

                        case 'initial_trans_wgt':
                            this.$set(this.form, 'sum_initial_trans_wgt', totals.initial_trans_wgt);
                            return totals.initial_trans_wgt;

                        case 'final_trans_wgt':
                            this.$set(this.form, 'sum_final_trans_wgt', totals.final_trans_wgt);
                            return totals.final_trans_wgt;

                        case 'loss_wgt':
                            this.$set(this.form, 'sum_loss_wgt', totals.loss_wgt);
                            return totals.loss_wgt;

                        default:
                            return '-';
                    }
                })
            ];
        },

        handleInput(row, field, type) {
            // 如果不是数字类型，直接返回
            if (type !== 'number') return;

            // 获取当前输入值
            let inputValue = row[field];

            // 如果输入值为空或不是字符串，设置为空字符串
            if (inputValue === null || inputValue === undefined) {
                row[field] = '';
                return;
            }

            // 转换为字符串处理
            inputValue = String(inputValue);

            // 保留数字、小数点和负号
            let cleanedValue = inputValue.replace(/[^0-9.-]/g, '');

            // 只保留第一个小数点
            const decimalIndex = cleanedValue.indexOf('.');
            if (decimalIndex !== -1) {
                cleanedValue = cleanedValue.substring(0, decimalIndex + 1) + cleanedValue.substring(decimalIndex + 1).replace(/\./g, '');
            }

            // 处理负号：只允许在开头有一个负号
            let negativeSign = '';
            if (cleanedValue.startsWith('-')) {
                negativeSign = '-';
                cleanedValue = cleanedValue.substring(1);
            }

            // 去掉中间或末尾的负号
            cleanedValue = cleanedValue.replace(/-/g, '');

            // 如果只有小数点，转换为 0.
            if (cleanedValue === '.') {
                cleanedValue = '0.';
            }

            // 合并负号和处理后的值
            row[field] = negativeSign + cleanedValue;
        }
        ,
        /**
         * 表格跳转方法
         */
        jumptable(e, row, type, tableRef) {
            // 获取指定表格的引用
            const table = this.$refs[tableRef];
            if (!table) return;

            // 所有列数据
            let column = table.getTableColumn().fullColumn;
            // 所有行数据
            var rows = table.getTableData().fullData;
            // 根据当前行获取行下标
            var rowIndex = table.getVTRowIndex(row);
            // 当前列
            let nowcolumn = table.getColumnByField(type);
            // 根据当前列获取下标
            let columnIndex = table.getColumnIndex(nowcolumn);
            // 列数据总长度
            var length = column.length;

            // 计算需要跳过的列数
            var addnum = 1; // 跳过列的基本参数
            var addnumleft = 1;

            // 处理向右跳转时需要跳过的列
            if (column[columnIndex + 1]) {
                if (column[columnIndex + 1].className == 'jump') {
                    let newColumn = column.slice(columnIndex + 1);
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnum += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {
                    }
                }
            }

            // 处理向左跳转时需要跳过的列
            if (column[columnIndex - 1]) {
                if (column[columnIndex - 1].className == 'jump') {
                    let newColumn = column.slice(0, columnIndex).reverse();
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnumleft += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {
                    }
                }
            }

            // 右移目标列
            var jumpnum = columnIndex + addnum;
            if (column[jumpnum]) {
                var downtype = column[jumpnum].property;
            }

            // 左移目标列
            var jumpnumleft = columnIndex - addnumleft;
            if (column[jumpnumleft]) {
                var uptype = column[jumpnumleft].property;
            }

            // 右移/回车/Tab键处理
            if (e.keyCode == '39' || e.keyCode == '13' || e.keyCode == '9') {
                // 检查是否是最后一行且最后一列
                if (jumpnum >= length && rowIndex + 1 >= rows.length) {
                    // 最后一行的最后一列，增加新行
                    if (tableRef === 'dtlTable') {
                        this.addDtl();
                    } else if (tableRef === 'billTable') {
                        this.addbill();
                    } else if (tableRef === 'amtTable') {
                        this.addamt();
                    }

                    // 更新行数据
                    this.$nextTick(() => {
                        const newRows = table.getTableData().fullData;
                        if (newRows.length > rowIndex + 1) {
                            // 跳转到新行的第一列可编辑单元格
                            setTimeout(() => {
                                table.setActiveRow(newRows[rowIndex + 1]);
                            }, 100);
                        }
                    });
                } else if (jumpnum >= length) {
                    // 最后一列但不是最后一行，换行到下一行第一列
                    if (rowIndex + 1 < rows.length) {
                        setTimeout(() => {
                            table.setActiveRow(rows[rowIndex + 1]);
                        }, 100);
                    }
                } else {
                    // 不是最后一列，跳转到下一列
                    let allowBreak = true;

                    if (allowBreak) {
                        table.setActiveCell(row, downtype);
                    }
                }
            }

            // 左移键处理
            if (e.keyCode == '37') {
                if (jumpnumleft < 0 && rowIndex > 0) {
                    // 第一列且不是第一行，跳转到上一行
                    table.setActiveRow(rows[rowIndex - 1]);
                } else if (jumpnumleft >= 0) {
                    // 不是第一列，跳转到上一列
                    table.setActiveCell(row, uptype);
                }
            }

            // 下箭头键处理
            if (e.keyCode == '40') {
                e.preventDefault(); // 阻止默认行为
                // 如果是最后一行，则增加新行
                if (rowIndex + 1 >= rows.length) {
                    if (tableRef === 'dtlTable') {
                        this.addDtl();
                    } else if (tableRef === 'billTable') {
                        this.addbill();
                    } else if (tableRef === 'amtTable') {
                        this.addamt();
                    }

                    // 更新行数据并跳转到新行
                    this.$nextTick(() => {
                        const newRows = table.getTableData().fullData;
                        if (newRows.length > rowIndex + 1) {
                            setTimeout(() => {
                                table.setActiveCell(newRows[rowIndex + 1], nowcolumn.property);
                            }, 100);
                        }
                    });
                } else {
                    // 不是最后一行，跳转到下一行相同列
                    table.setActiveCell(rows[rowIndex + 1], nowcolumn.property);
                }
            }

            // 上箭头键处理
            if (e.keyCode == '38') {
                e.preventDefault(); // 阻止默认行为
                // 确保不是第一行
                if (rowIndex - 1 >= 0) {
                    // 跳转到上一行相同列
                    table.setActiveCell(rows[rowIndex - 1], nowcolumn.property);
                }
            }
        }

    }
};
</script>

<style scoped lang="scss">
.avatar {
    width: 150px;
    height: 150px;
    display: block;
}

.table1 {
    padding: 15px;
    box-sizing: border-box;
    background-color: #fff;
    margin-top: 10px;
    padding-top: 0;

    .title {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
            font-size: 16px;
            color: #000;
        }
    }

    .ipt {
        display: flex;
        align-items: center;
        width: 20%;

        p {
            font-size: 16px;
            color: #000;
            width: 30%;
        }
    }
}

.table_warpper {
    display: flex;

    .table2 {
        width: 60%;
        margin-right: 15px;
    }

    .table3 {
        width: 40%;
    }
}
</style>
<style>
/* .el-dialog__wrapper {
    left: 30%;
} */
.vxe-table .vxe-body--row.row--stripe {
    background-color: #ecf5ff;
}

.vxe-table thead {
    background-color: #ecf5ff;
}

.vxe-table {
    background: #fff;
}

.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}

.box1 .el-select {
    width: 20%;
}

.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}

.el-select {
    width: 100%;
}

.list-item1:hover {
    background-color: #f5f7fa;
}

.orderorder {
    padding-bottom: 65px;
    box-sizing: border-box;
}

.orderorder .vxe-table .vxe-body--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-footer--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 12px 0;
}

.orderorder .vxe-table--footer-wrapper.body--wrapper {
    color: red;
}
</style>
<style scoped lang="scss">
.batchBtn {
    margin-left: 5px;
    display: inline-block;
    padding: 4px 8px;
    border: 1px solid #409eff !important;
}

.footer {
    height: 88px;
    background-color: #fff;
    z-index: 999;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: 98%;
    box-shadow: 0px -2px 6px 0px #e2eeff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;
    box-sizing: border-box;

    div {
        display: flex;

        p {
            width: 20%; /* 调整为百分比 */
            min-width: 80px; /* 保证在极小的屏幕上也不会过小 */
        }

        .buttom {
            height: 32px;
            line-height: 0;
        }

        .el-form-item {
            margin-right: 15px;
            margin-bottom: 5px;
        }
    }
}

.importDialogCenter {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;

    .centerItem {
        width: 48%;
        text-align: center;

        /deep/ .el-upload--text {
            width: 100%;
        }

        /deep/ .el-upload-dragger {
            width: 100%;
        }
    }

    .leftItem {
        width: 48%;
        height: 180px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        border-radius: 8px;
        border: 1px dashed #97a8be;

        .itemText {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    // width: 178px;
    // height: 178px;
    line-height: 178px;
    text-align: center;
}

.el-tag {
    margin-right: 10px;
    margin-bottom: 10px;
}

.button-new-tag {
    margin-left: 10px;
}

.inbound {
    width: 100%;
    margin-top: 10px;
    background-color: #fff;

    .title {
        width: 100%;
        font-size: 16px;
        padding: 15px;
        box-sizing: border-box;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;

        i {
            color: #409eff;
        }
    }

    .table {
        padding: 0 15px;
        padding-bottom: 15px;
    }
}
</style>
